var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { ProblemDetails } from '../ProblemDetails.js';
import { ApiException } from '../ApiException.js';
import { BaseTokenClient } from '../BaseTokenClient.js';
export class TokenClient extends BaseTokenClient {
  /**
   * Constructor for a TokenClient used to interact with the Laserfiche Self-Hosted token endpoint.
   * @param baseUrl - APIServer Base Url e.g. https://\{APIServerName\}/LFRepositoryAPI
   */
  constructor(baseUrl) {
    super();
    this._createAccessTokenErrMsg = "Get access token error.";
    if (!baseUrl) throw new Error('baseUrl is undefined.');
    this._baseUrl = baseUrl.endsWith('/') ? baseUrl.substring(0, baseUrl.length - 1) : baseUrl;
  }
  createAccessToken(repositoryId, body) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
      const encodedGrantType = body.grant_type ? encodeURIComponent(body.grant_type) : '';
      const encodedUsername = body.username ? encodeURIComponent(body.username) : '';
      const encodedPassword = body.password ? encodeURIComponent(body.password) : '';
      const req = {
        method: 'POST',
        headers: new Headers({
          'content-type': 'application/x-www-form-urlencoded',
          'accept': 'application/json'
        }),
        body: `grant_type=${encodedGrantType}&username=${encodedUsername}&password=${encodedPassword}`
      };
      const url = this._baseUrl + `/v1/Repositories/${encodeURIComponent(repositoryId)}/Token`;
      const res = yield fetch(url, req);
      if (res.status === 200) {
        const getAccessTokenResponse = yield res.json();
        return getAccessTokenResponse;
      } else if (((_a = res.headers.get('Content-Type')) === null || _a === void 0 ? void 0 : _a.includes('json')) === true) {
        const errorResponse = yield res.json();
        const problemDetails = ProblemDetails.fromJS(errorResponse);
        const apiException = new ApiException((_b = problemDetails.title) !== null && _b !== void 0 ? _b : this._createAccessTokenErrMsg, problemDetails.status, res.headers, problemDetails);
        throw apiException;
      } else {
        throw new ApiException(this._createAccessTokenErrMsg, res.status, res.headers, null);
      }
    });
  }
}
